import React, {useState} from 'react'
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import Loader from '../../atoms/loader';
import { liveQaSignup } from '../../../../server/handlers/sendgrid-campaigns';
import { isValidEmail } from '../../../utils';
import { TextField} from "../../atoms/textfield"
import CloseIcon from "../../../../assets/images/close.png"

import "./newsletter-input.m.css";

export const NewsletterInput = ({story, setShowEmailInput}) => {
    const [emailID, setEmailID] = useState("")
    const [error, setError] = useState(null)
    const [showLoader, setShowLoader] = useState(false)
    const eventTitle = get(story,"headline", null)
    const eventDate = new Date(get(story, ["metadata", "event-date"] ,null))
  
    const handleSubmit = async() => {
     
      try{
        setShowLoader(true);
        if (emailID) {
          if (!isValidEmail(emailID)) {
            throw "Invalid Email!";
           
          } else {
              const res = await liveQaSignup(
                emailID,
                '37ed0d54-1a27-42c3-addd-0531914f9a4d', 
                eventTitle, 
                eventDate 
              )
              res && setShowEmailInput(false)
          } 
        } else {
          throw "Please provide email!";
        }
      } catch(err) {
          setError(err)
      } finally {
        setEmailID("");
        setShowLoader(false)
      }
    }
  
    return(
        <div styleName="notification-reminder-wrapper">  
          <i className="material-icons" >mark_email_unread</i>
          <p>Get notified when we go live</p> 
          <div styleName="newsletter-input-wrapper">
          
            <TextField value={emailID} error={error} onChange={e=>setEmailID(e.target.value)} placeholder="Type your email" />
            <button styleName="submit-btn" onClick={handleSubmit}>
              {showLoader?<Loader/>:"Get a Reminder "}
            </button>
            {/* {error&&<p>{error}</p>} */}
          </div>
          <img onClick={()=>setShowEmailInput(false)} styleName="close-email" src={assetify(CloseIcon)}/>
        </div>
    )
  }